// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cTWrB","name":"styles_name__1gF6N","phone":"styles_phone__20nv3"};